export default "__VITE_ASSET__01d11636__"